
import React from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Slider } from "@/components/ui/slider";
import { BucketFormData } from "../forms/BucketFormData";
import { BudgetBucket } from "../../types/budget.types";

interface EditBucketDialogProps {
  isOpen: boolean;
  onClose: () => void;
  formData: BucketFormData;
  selectedBucket: BudgetBucket | null;
  onFormChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onAllocationSliderChange: (value: number[]) => void;
  onBudgetChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onUpdate: () => Promise<void>;
}

export const EditBucketDialog: React.FC<EditBucketDialogProps> = ({
  isOpen,
  onClose,
  formData,
  selectedBucket,
  onFormChange,
  onAllocationSliderChange,
  onBudgetChange,
  onUpdate
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Edit Budget Bucket</DialogTitle>
          <DialogDescription className="text-primary">
            Update budget allocation for this category
          </DialogDescription>
        </DialogHeader>
        
        <div className="grid gap-4 py-4">
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="customName" className="text-right">
              Name
            </Label>
            <Input 
              id="customName" 
              name="customName" 
              className="col-span-3" 
              value={formData.customName} 
              onChange={onFormChange} 
            />
          </div>
          
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="allocationPercentage" className="text-right">
              Allocation %
            </Label>
            <div className="col-span-3 flex items-center gap-4">
              <Slider 
                value={[formData.allocationPercentage]} 
                max={100} 
                step={1} 
                className="flex-1" 
                onValueChange={onAllocationSliderChange} 
              />
              <span className="w-12 text-center">{Math.round(formData.allocationPercentage)}%</span>
            </div>
          </div>
          
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="budget" className="text-right">
              Budget ($)
            </Label>
            <Input 
              id="budget" 
              name="budget" 
              type="number" 
              className="col-span-3" 
              value={formData.budget} 
              onChange={onBudgetChange} 
            />
          </div>
          
          {selectedBucket && parseInt(formData.budget || "0") < selectedBucket.budget - selectedBucket.available && (
            <div className="bg-red-500/10 border border-red-500/30 p-3 rounded-md text-sm">
              <p className="text-red-500">
                Error: New budget is less than the amount already allocated to subcategories 
                (${(selectedBucket.budget - selectedBucket.available).toLocaleString()})
              </p>
            </div>
          )}
        </div>
        
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={onUpdate}>
            Save Changes
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
